import { render, staticRenderFns } from "./ProjectMembersPage.vue?vue&type=template&id=3f19adf8&scoped=true&lang=pug&"
import script from "./ProjectMembersPage.vue?vue&type=script&lang=js&"
export * from "./ProjectMembersPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMembersPage.vue?vue&type=style&index=0&id=3f19adf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f19adf8",
  null
  
)

export default component.exports